import React, { useState, useEffect } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Progress Bar */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-neon-pink via-trophy-gold to-success-green origin-left z-[100]"
        style={{ scaleX }}
      />

      {/* Pixel corners */}
      <div className="fixed top-0 left-0 w-2 h-2 bg-neon-pink z-[101]" />
      <motion.div
        className="fixed top-0 right-0 w-2 h-2 bg-success-green z-[101]"
        style={{ opacity: scrollYProgress }}
      />

      {/* Scroll to Top Button */}
      <motion.button
        initial={{ opacity: 0, scale: 0 }}
        animate={{
          opacity: showScrollTop ? 1 : 0,
          scale: showScrollTop ? 1 : 0,
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 w-12 h-12 bg-neon-pink rounded-lg flex items-center justify-center z-50 border-2 border-dark-border shadow-[0_0_20px_rgba(255,0,128,0.4)]"
        style={{ cursor: 'none' }}
      >
        {/* Pixel Arrow Up */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="11" y="6" width="2" height="12" fill="#1a0a2e" />
          <rect x="9" y="8" width="2" height="2" fill="#1a0a2e" />
          <rect x="13" y="8" width="2" height="2" fill="#1a0a2e" />
          <rect x="7" y="10" width="2" height="2" fill="#1a0a2e" />
          <rect x="15" y="10" width="2" height="2" fill="#1a0a2e" />
        </svg>
      </motion.button>

      {/* Side Progress Dots */}
      <div className="fixed right-4 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col gap-3">
        {['hero', 'leaderboard', 'what-it-is', 'how-it-works', 'side-quests', 'partners', 'testimonials', 'submit', 'faq'].map((section, index) => (
          <motion.a
            key={section}
            href={`#${section === 'hero' ? '' : section}`}
            className="w-2 h-2 rounded-full bg-panel-purple hover:bg-neon-pink transition-colors"
            whileHover={{ scale: 1.5 }}
            style={{ cursor: 'none' }}
          />
        ))}
      </div>
    </>
  );
};

export default ScrollProgress;
